'use client'

import { hasAcceptedCookies } from '@/lib/client/cookies'
import { GoogleTagManager } from '@next/third-parties/google'
import React, { Suspense } from 'react'
import DonatePopup from '@/components/DonatePopup/Component'
import AppStorageEffect from '@/lib/client/app-storage/AppStorageEffect'
import CookieConsent from '@/components/CookieConsent'

export default function RootLayoutClient({children}: {children: React.ReactNode}) {
  return <>
    {hasAcceptedCookies() && process.env.NEXT_PUBLIC_GOOGLE_GTM_ID && (
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GOOGLE_GTM_ID} />
    )}

    {children}

    <DonatePopup />
    <Suspense fallback={null}>
      <AppStorageEffect />
    </Suspense>
    <CookieConsent />
  </>
}
